// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * Which games are played with the round's round-level teams rather than the pairs inside a ball.
 *
 * Mirrors `BallTeams.RoundTeamsAreTheTeams` in games-service, which is the authority. A round
 * team's members may sit in different balls, so such a game is ranked across the round and its
 * teams are set up on the round-start board, not derived from the groups.
 */
export function usesRoundTeams(game: { name?: string | null } | null | undefined): boolean {
  return (game?.name ?? '').trim().toLowerCase() === 'best of team';
}
